import type { TGlobalSearchTranslate } from "@frontend-shared/types";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { defaultLanguage } from "@/i18n/languages";
import { createGlobalSearchTranslate } from "@/lib/global-search/create-global-search-translate";

// NOTE: Rebuilt on a language change so every palette title follows it.
export const useGlobalSearchTranslate = (): TGlobalSearchTranslate => {
  const { i18n } = useTranslation();
  const language = i18n.language;

  return useMemo(
    () =>
      createGlobalSearchTranslate({
        translator: i18n,
        language,
        fallbackLanguage: defaultLanguage,
      }),
    [i18n, language],
  );
};
